import { makeStyles } from '@material-ui/core';

const useAutoCompleteStyles = makeStyles(() => ({
  root: {
    '& .MuiFormLabel-root.Mui-error':{
      color:'var(--light-venetian-red)'
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline':{
      borderColor:'var(--light-venetian-red)'
    },
    '&:focus-within label span, &:hover label span':{
      color:'var(--teal-blue)'
    },
    '& .MuiAutocomplete-inputRoot': {
      height: 'fit-content'
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '14.5px 4px'
    }
  },
  select: {
    backgroundColor: 'rgba(0, 0, 0, 0) !important'
  },
  checkbox:{
    padding:'0 !important',
    marginRight:'8px'
  },
  requiredAsterisk: {
    marginLeft: '3px',
    color: 'var(--light-venetian-red) !important'
  },
  error:{
    color: 'var(--light-venetian-red) !important'
  },
  helpTooltipAdornmentWrapper: {
    top: 'calc(50% - 13px)',
    position: 'absolute',
    right: '36px',
    zIndex: 1,
    cursor: 'auto',

    '& svg': {
      color: 'var(--teal-blue)'
    }
  },
  helpTooltipAdornment: {
    '& .MuiAutocomplete-clearIndicator': {
      marginRight: '26px'
    }
  }
}));

export default useAutoCompleteStyles;